import {cnCreateForm} from '../../FormModule';
import {cnModal, Modal} from '../../../../../components/Modal';
import React, {useState} from 'react';
import {TEditKitFurniture} from './KitFurniture';
import {editOption, editReverseOption} from '../../../utils/editOption';
import {furnitureCells, kitCodes, sideTypes} from '../../constants/constants';
import {Select} from '../../../../../components/Select/Select';
import {IKitFurniturePriceParam} from '../../../../../../../common-code/interfaces/catalog/IKitFurniturePriceParam';
import {useDispatch, useSelector} from 'react-redux';
import {AppState} from '../../../../../../redux/AppStore';
import {fetchOptions, saveOptions} from '../../../api/OptionsServices';
import {CHANGE_KIT_FURNITURE_FUNCTION_TYPES} from '../../../../../../constants';
import {useEffectDidMount} from '../../../../../../hooks/useEffectDidMount';
import AddOptions from '../../components/AddOptions';
import {Textinput} from '@yandex/ui/Textinput/desktop/bundle';
import ModalKitFurnitureSizes from './ModalKitFurnitureSizes';
import {Button} from '../../../../../components/Button';
import {TDetailCalculateSizes} from '../../../../../../../common-code/types/detail/TDetailCalculateSizes';
import {KitchenService} from '../../../../../../3d/services/KitchenService/KitchenService';
import {IImportOffer} from '../../../../../../../common-code/interfaces/api/IImportOffer';
interface  ModalKitFurnitureItemProps {
    showModal: boolean
    handleSubmit: (editData: TEditKitFurniture) => void
    handleToggleModal: () => void
    editData: TEditKitFurniture,
    keyValue: string;
    service: KitchenService;
}
type TParamErrors = {
    kitCode?: string;
    cell?: string;
    functionalType?: string;
    count?: string;
}
function ModalKitFurnitureItem ({showModal, handleSubmit, editData, handleToggleModal, keyValue, service}: ModalKitFurnitureItemProps) {

    const isEdit = editData.index !== undefined;
    const title = `${isEdit ? 'Редактирование' : 'Добавление'} фурнитуры`;
    const [editParam, setEditParam] = useState<IKitFurniturePriceParam>(editData.data);
    const dispatch = useDispatch();
    const [errors, setErrors] = useState<TParamErrors>({});
    const [findOffer, setFindOffer] = useState<IImportOffer | undefined>(service.calculateKitFurnitureOffer(
        editParam,
        editData.parentSizes
    ))

    const setNewEditParams = (newEditParam: IKitFurniturePriceParam) => {
        setEditParam(newEditParam);
        setFindOffer(service.calculateKitFurnitureOffer(newEditParam, editData.parentSizes));
    }
    const onInputChange = (
        e:
            | React.ChangeEvent<HTMLInputElement>
            | React.ChangeEvent<HTMLSelectElement>
    ) => {
        setNewEditParams({
            ...editParam,
            [e.target.name]: e.target.value
        })
    }

    const onSizesChange = (name: string, value: string) => {
        let newSizes: TDetailCalculateSizes = editParam.sizes ? {...editParam.sizes} : {};
        newSizes[name as keyof TDetailCalculateSizes] = value;
        setNewEditParams({
            ...editParam,
            sizes: newSizes
        })
    }
    const [funcTypes, setFuncTypes] = React.useState<Record<string, string>>(
        useSelector(
            (state: AppState) => state.wizard.editModule?.kitFurnitureFuncTypes
        ) || {}
    )
    // добавление функциональных типов фасадов
    const addKitFurnitureFuncTypes = (funcTypesNew: Record<string, string>) => {
        setFuncTypes(funcTypesNew)
        saveOptions(funcTypesNew, 'kit-furniture-function-types').then(
            (res: Record<string, string> | undefined) => {
                if (res)
                    dispatch({
                        type: CHANGE_KIT_FURNITURE_FUNCTION_TYPES,
                        payload: res,
                    })
            }
        )
    }

    // если типы фасадов еще не получены загружаем их с сервера
    useEffectDidMount(() => {
        if (Object.keys(funcTypes).length === 0) {
            fetchOptions('kit-furniture-function-types').then(
                (res: Record<string, string> | undefined) => {
                    if (res) {
                        setFuncTypes(res)
                        dispatch({
                            type: CHANGE_KIT_FURNITURE_FUNCTION_TYPES,
                            payload: res,
                        })
                    }
                }
            )
        }
    })

    const validateKitFurniture = (param: IKitFurniturePriceParam): boolean => {
        let newErrors: TParamErrors = {};

        if (!param.kitCode) {
            newErrors.kitCode = "Комплектация обязательна для заполнения";
        }
        if (!param.cell) {
            newErrors.cell = "Расположение обязательно для заполнения";
        }
        if (!param.functionalType) {
            newErrors.functionalType = "Тип 1С обязателен для заполнения";
        }
        if (!param.count) {
            newErrors.count = "Количество обязательно для заполнения";
        }else if (isNaN(+param.count) || param.count < 1) {
            newErrors.count = "Количество должно быть числом больше 0";
        }
        setErrors(newErrors);

        return !Object.keys(newErrors).length;
    }

    const tryHandleSubmit = () => {
        if (validateKitFurniture(editParam)) {
            handleSubmit({
                data: editParam,
                parentSizes: editData.parentSizes,
                index: editData.index
            })
        }
    }

    return (
        <Modal
            className={cnCreateForm(cnModal())}
            visible={showModal}
            callBack={handleToggleModal}
            key={keyValue}
        >
            <h4 className={cnCreateForm('Header')}>{title}</h4>
            <div className={cnCreateForm('Content')}>
                {/* Поля ввода обязательные для заполнения */}
                <div>
                    <label htmlFor="kitCode">Комплектация *</label>
                    <Select
                        className={cnCreateForm('Select')}
                        placeholder={'Выберите значение'}
                        showPlaceholder={false}
                        options={editOption(kitCodes)}
                        value={editParam.kitCode}
                        callBack={(e) =>
                            onInputChange({
                                ...e,
                                target: {...e.target, name: 'kitCode'},
                            })
                        }
                    />
                    {errors.kitCode ? <p className={cnCreateForm('Error')}>{errors.kitCode}</p> : null}
                </div>
                <div>
                    <label htmlFor="cell">Расположение *</label>
                    <Select
                        className={cnCreateForm('Select')}
                        placeholder={'Выберите значение'}
                        showPlaceholder={false}
                        options={editOption(furnitureCells)}
                        value={editParam.cell}
                        callBack={(e) =>
                            onInputChange({
                                ...e,
                                target: {...e.target, name: 'cell'},
                            })
                        }
                    />
                    {errors.cell ? <p className={cnCreateForm('Error')}>{errors.cell}</p> : null}
                </div>
                <div>
                    <label htmlFor="functionalType">Тип из 1С *</label>
                    <Select
                        className={cnCreateForm('Select')}
                        placeholder={'Выберите значение'}
                        showPlaceholder={false}
                        options={editReverseOption(funcTypes)}
                        value={editParam.functionalType}
                        callBack={(e) =>
                            onInputChange({
                                ...e,
                                target: {
                                    ...e.target,
                                    name: 'functionalType',
                                },
                            })
                        }
                    />
                    <AddOptions
                        options={funcTypes}
                        setOptions={addKitFurnitureFuncTypes}
                    />
                    {errors.functionalType ? <p className={cnCreateForm('Error')}>{errors.functionalType}</p> : null}
                </div>
                <div>
                    <label htmlFor="count">Требуемое количество *</label>
                    <Textinput
                        className={cnCreateForm("Textinput")}
                        value={editParam.count}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            onInputChange(e)
                        }
                        name="count"
                    />
                    {errors.count ? <p className={cnCreateForm('Error')}>{errors.count}</p> : null}
                </div>
                <div>
                    <label htmlFor="sideType">Сторона (не обязательно)</label>
                    <Select
                        className={cnCreateForm('Select')}
                        placeholder={'Выберите значение'}
                        showPlaceholder={false}
                        options={editOption(sideTypes)}
                        value={editParam.sideType || ''}
                        callBack={(e) =>
                            onInputChange({
                                ...e,
                                target: {...e.target, name: 'sideType'},
                            })
                        }
                    />
                </div>
                <ModalKitFurnitureSizes param={editParam} onSizesChange={onSizesChange}/>
                <div>
                    <label>Найденный товар в каталоге:</label>
                    {
                        findOffer ?
                            <div>
                                <div>Код товара: <b>{findOffer.vendorCode}</b></div>
                                <div>Наименование: <b>{findOffer.name}</b></div>
                            </div> :
                            <div className={cnCreateForm('Error')}>Внимание! товар не найден в каталоге!</div>
                    }
                </div>
                <Button
                    className={cnCreateForm('Button')}
                    type={'button'}
                    text={`Применить`}
                    leftIcon={{
                        path: 'plus2',
                        width: 16,
                        height: 16,
                        marginRight: 8,
                    }}
                    mods={{
                        mods: {
                            bkg: 'white',
                            color: 'lightGreen',
                            border: 'lightGreen',
                            fill: 'lightGreen',
                        },
                        hover: {
                            mods: {
                                bkg: 'lightGreen',
                                color: 'white',
                                fill: 'white',
                            },
                        },
                    }}
                    callBack={tryHandleSubmit}
                />
            </div>
        </Modal>
    );
}

export default ModalKitFurnitureItem;